/**
 * Global Swiper bootstrap (Swiper is loaded from layout/theme.liquid).
 * - Inits product sliders marked with [data-products-slider-root][data-pswiper-needs-lib="true"].
 * - Exposes window.ThemeSwiper for other sections: .whenReady(), .getSwiper(), .initProductSliders().
 */
(function () {
  var MAIN_GUARD = '__ThemeSwiperBootstrap';

  function whenSwiper(callback) {
    if (typeof window.Swiper === 'function') {
      callback();
      return;
    }
    var attempts = 0;
    var id = setInterval(function () {
      attempts += 1;
      if (typeof window.Swiper === 'function') {
        clearInterval(id);
        callback();
      } else if (attempts > 120) {
        clearInterval(id);
      }
    }, 25);
  }

  function rootsToInit() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-products-slider-root][data-pswiper-needs-lib="true"]:not([data-pswiper-inited])')
    );
  }

  function initProductSliderRoot(root) {
    if (root.getAttribute('data-pswiper-inited') === 'true') return;
    var el = root.querySelector('.products-slider__swiper');
    if (!el || typeof window.Swiper !== 'function') return;

    var prevEl = root.querySelector('.products-slider__nav--prev');
    var nextEl = root.querySelector('.products-slider__nav--next');
    var paginationEl = root.querySelector('.products-slider__pagination');

    try {
      var swiperOptions = {
        slidesPerView: 1,
        spaceBetween: 16,
        speed: 400,
        watchOverflow: true,
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        },
        pagination: {
          el: paginationEl,
          clickable: true,
        },
      };
      if (prevEl && nextEl) {
        swiperOptions.navigation = {
          prevEl: prevEl,
          nextEl: nextEl,
        };
      }
      var sw = new window.Swiper(el, swiperOptions);
      root._productsSliderSwiper = sw;
      root.setAttribute('data-pswiper-inited', 'true');
    } catch (e) {
      console.warn('[theme-swiper] Products slider init failed', e);
    }
  }

  function initAllProductSliders() {
    rootsToInit().forEach(initProductSliderRoot);
  }

  function onSectionLoad(ev) {
    var sec = ev.target;
    if (!sec || !sec.querySelectorAll) return;
    var inner = sec.querySelectorAll('[data-products-slider-root]');
    if (!inner.length) return;
    inner.forEach(function (r) {
      r.removeAttribute('data-pswiper-inited');
      if (r._productsSliderSwiper && typeof r._productsSliderSwiper.destroy === 'function') {
        try {
          r._productsSliderSwiper.destroy(true, true);
        } catch (e) {}
        r._productsSliderSwiper = null;
      }
    });
    whenSwiper(initAllProductSliders);
  }

  function boot() {
    whenSwiper(initAllProductSliders);
  }

  window.ThemeSwiper = window.ThemeSwiper || {
    whenReady: whenSwiper,
    getSwiper: function () {
      return typeof window.Swiper === 'function' ? window.Swiper : null;
    },
    initProductSliders: initAllProductSliders,
  };

  if (window[MAIN_GUARD]) return;
  window[MAIN_GUARD] = true;

  if (window.Shopify && window.Shopify.designMode && !window.__ThemeSwiperSectionListener) {
    window.__ThemeSwiperSectionListener = true;
    document.addEventListener('shopify:section:load', onSectionLoad);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
